import { Injectable } from '@angular/core';
import {BaseurlService} from '../services/baseurl.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapService {

  private readonly localStorageKey = 'gpx-file-config';

  private fromLimit: string | undefined = undefined;
  private untilLimit: string | undefined = undefined;

  constructor(
    private readonly baseurlService: BaseurlService,
    private readonly http: HttpClient,
  ) { }

  getAllTracks(): Observable<SimpleGpxDtoRoot[]> {
    return this.http.get<SimpleGpxDtoRoot[]>(`${this.baseurlService.getBaseUrl()}/gpx/all`);
  }

  getSpecificTracks(names: string[]): Observable<SimpleGpxDtoRoot[]> {
    return this.http.post<SimpleGpxDtoRoot[]>(`${this.baseurlService.getBaseUrl()}/gpx/specific`, names);
  }

  getFileInfo(): Observable<GpxFileInfo[]> {
    return this.http.get<GpxFileInfo[]>(`${this.baseurlService.getBaseUrl()}/gpx/list`);
  }

  isFileActive(name: string): boolean {
    const stored = window.localStorage.getItem(this.localStorageKey);
    if (!stored) {
      return false;
    }
    const parsed: GpxFrontendConfig[] = JSON.parse(stored);
    if (!parsed) {
      return false;
    }
    const found = parsed.find((x: GpxFrontendConfig) => x.name === name);
    if (!found) {
      return false;
    }
    return found.active;
  }

  setFileActive(name: string, active: boolean) {
    const stored = window.localStorage.getItem(this.localStorageKey);
    let parsed: GpxFrontendConfig[] = stored ? JSON.parse(stored) : [];
    if (!parsed) {
      parsed = [];
    }
    let found = parsed.find((x: GpxFrontendConfig) => x.name === name);
    if (!found) {
      found = {name, active: false, color: '#000000'};
      parsed.push(found);
    }
    found.active = active;
    window.localStorage.setItem(this.localStorageKey, JSON.stringify(parsed));
  }

  listActiveFiles(): string[] {
    const stored = window.localStorage.getItem(this.localStorageKey);
    if (!stored) {
      return [];
    }
    const parsed: GpxFrontendConfig[]  = JSON.parse(stored);
    if (!parsed) {
      return [];
    }
    return parsed.filter(it => it.active).map(it => it.name);
  }

  getFileColor(name: string): string {
    console.log('getFileColor: ' + name);
    const stored = window.localStorage.getItem(this.localStorageKey);
    if (!stored) {
      return '#000000';
    }
    const parsed: GpxFrontendConfig[]  = JSON.parse(stored);
    if (!parsed) {
      return '#000000';
    }
    const found = parsed.find(x => x.name === name);
    if (!found) {
      return '#000000';
    }
    return found.color;
  }

  setFileColor(name: string, color: string) {
    const stored = window.localStorage.getItem(this.localStorageKey);
    let parsed: GpxFrontendConfig[] = stored ? JSON.parse(stored) : [];
    if (!parsed) {
      parsed = [];
    }
    let found = parsed.find((x: GpxFrontendConfig) => x.name === name);
    if (!found) {
      found = {name, active: false, color: '#000000'};
      parsed.push(found);
    }
    found.color = color;
    window.localStorage.setItem(this.localStorageKey, JSON.stringify(parsed));
  }

  getDateFromLimit() {
    return this.fromLimit;
  }

  getDateUntilLimit() {
    return this.untilLimit;
  }

  setDateFromLimit(text: string) {
    if (!text) {
      this.fromLimit = undefined;
    } else {
      this.fromLimit = text;
    }
  }

  setDateUntilLimit(text: string) {
    if (!text) {
      this.untilLimit = undefined;
    } else {
      this.untilLimit = text;
    }
  }

  ensureWithinLimits(point: SimpleGpxDtoPoint): boolean {
    if (this.fromLimit && this.fromLimit > point.time) {
      return false;
    }
    if (this.untilLimit && this.untilLimit < point.time) {
      return false;
    }
    return true;
  }
}


export interface SimpleGpxDtoRoot {
  name: string;
  points: SimpleGpxDtoPoint[];
}

export interface SimpleGpxDtoPoint {
  lat: number;
  lon: number;
  time: string;
}

export interface GpxFileInfo {
  name: string;
  points: number;
  startTime?: string;
  endTime?: string;
}

export interface GpxFrontendConfig {
  name: string;
  active: boolean;
  color: string;
}
